/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Updatetitle2Inputs */

const zh_organizationsettings_updatetitle2 = /** @type {(inputs: Organizationsettings_Updatetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新你的组织信息`)
};

const en_organizationsettings_updatetitle2 = /** @type {(inputs: Organizationsettings_Updatetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your organization information`)
};

const es_organizationsettings_updatetitle2 = /** @type {(inputs: Organizationsettings_Updatetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiza la información de tu organización`)
};

/**
* | output |
* | --- |
* | "Update your organization information" |
*
* @param {Organizationsettings_Updatetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_updatetitle2 = /** @type {((inputs?: Organizationsettings_Updatetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Updatetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_updatetitle2(inputs)
	if (locale === "en") return en_organizationsettings_updatetitle2(inputs)
	return es_organizationsettings_updatetitle2(inputs)
});
export { organizationsettings_updatetitle2 as "organizationSettings_updateTitle" }